import React, { Component } from 'react';
import { SelectedForVerification } from './SelectedForVerification';

class ResultsInputContainer extends Component {
  path = '/resultsinput';
  render() {
    return <SelectedForVerification isConfirmation={false} />;
  }
}

export const ResultsInput = ResultsInputContainer;



// WEBPACK FOOTER //
// ./src/pages/selectedforverification/ResultsInput.js